import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose"; // @flow

import React, { useContext, useEffect } from 'react';
import { TabsContext } from '..';
import Theme from './theme';
export var TabTheme = Theme;
/*::
import type { Node } from 'react';
import type { TabThemeType } from './theme';
import type { OnChangeType } from '..';

type TabPropsType = {|
  id: string,
  active?: boolean,
  onActivate?: OnChangeType,
  children?: Node,
  theme?: TabThemeType,
  rest?: any,
|};
*/

var Tab = function Tab(_ref
/*: TabPropsType */
) {
  var id = _ref.id,
      active = _ref.active,
      children = _ref.children,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? Theme : _ref$theme,
      rest = _objectWithoutPropertiesLoose(_ref, ["id", "active", "children", "theme"]);

  var _useContext = useContext(TabsContext),
      activeTab = _useContext.activeTab,
      onTabClick = _useContext.onTabClick,
      setActiveTab = _useContext.setActiveTab;

  var handleTabClick = function handleTabClick() {
    setActiveTab(id);
    onTabClick(id);
  };

  useEffect(function () {
    if (active) setActiveTab(id);
  }, []);
  return /*#__PURE__*/React.createElement(theme.Main, Object.assign({
    className: id === activeTab && 'active',
    onClick: handleTabClick,
    onKeyDown: function onKeyDown(e
    /*: any */
    ) {
      if (e.key === 'Enter') {
        handleTabClick();
      }
    },
    tabIndex: 0,
    "data-id": id,
    "data-test": "tabs-tab-main"
  }, rest), children);
};

export default Tab;